import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { myInformationReducer } from './reducer';
import { MyInformationStoreEffects } from './effects';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature('MyInformation', myInformationReducer), EffectsModule.forFeature([MyInformationStoreEffects])],
  providers: [MyInformationStoreEffects],
})
export class MyInformationStoreModule {
  MyInformation: any;
}
